export const rupiah = (n) =>
  "Rp" + Number(n || 0).toLocaleString("id-ID");

export const rupiahShort = (n) => {
  if (n >= 1000) return "Rp" + Math.round(n / 1000) + "k";
  return "Rp" + n;
};

// Haversine distance in km between [lat,lng] pairs
export function distKm(a, b) {
  if (!a || !b) return null;
  const R = 6371;
  const dLat = ((b[0] - a[0]) * Math.PI) / 180;
  const dLng = ((b[1] - a[1]) * Math.PI) / 180;
  const la1 = (a[0] * Math.PI) / 180;
  const la2 = (b[0] * Math.PI) / 180;
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(la1) * Math.cos(la2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

export const fmtKm = (km) => (km == null ? "" : km < 1 ? `${Math.round(km * 1000)} m` : `${km.toFixed(1)} km`);
